import { EnvConfig } from '@core/config';

export const environment: EnvConfig = {
  apiUrl: 'https://backend-development-724435531317.europe-west3.run.app/api',
  googleMapsApiKey: 'AIzaSyBZaRTCpNvCETJSxJCgsdSFf2mdWCIjRkA',
  ibanKey: '333c5cdec7e86b4639237b6e540a309cbb3dd726',
  currencyCode: 'EUR',
  enforcedLocaleId: null,
  impressumUrl: 'https://kapnative.com/en/imprint',
  privacyPolicyUrl: 'https://kapnative.com/en/privacy',
  production: false,
  supportFormUrl: 'https://kapnative.com/en/contact-us#contact-form',
  termsAndConditionsUrl: 'https://kapnative.com/en/disclaimer',
  microsoftUrl: 'https://www.microsoft.com/en-us/security/mobile-authenticator-app#overview',
  allowPublic: true,
  recaptchaSiteKey: '6LfkeQIrAAAAADXgr0kCpvAF4xPZl0JzPdqSRGhB',
  aiEngineApiUrl: 'https://ai-engine-api-dev-724435531317.europe-west3.run.app',
  tosUrls: {
    default: {
      impressumUrl: 'https://kapnative.com/en/imprint',
      privacyPolicyUrl: 'https://kapnative.com/en/privacy',
      supportFormUrl: 'https://kapnative.com/en/contact-us#contact-form',
      termsAndConditionsUrl: 'https://kapnative.com/en/disclaimer',
    },
    partnerTheme: {
      impressumUrl: 'https://ready4impact.de/impressum',
      privacyPolicyUrl: 'https://ready4impact.de/datenschutz',
      supportFormUrl: 'https://ready4impact.de',
      termsAndConditionsUrl: 'https://ready4impact.de',
    },
  },
};
